import React, { ReactNode } from 'react';
import { Square } from '@grubhubprod/gh-cookbook-react';

interface ParentAdminTableCellProps {
  children: ReactNode;
}

export const ParentAdminTableCell: React.FC<ParentAdminTableCellProps> = ({
  children,
}) => {
  return (
    <Square inset="md" alignItems="center">
      {children}
    </Square>
  );
};
